import { hasLocale } from 'next-intl';
import { defineRouting } from 'next-intl/routing';

export const locales = ['ru', 'en'] as const;
export type Locale = (typeof locales)[number];

// localeCookie + localeDetection выключены намеренно: русские URL в корне
// не должны редиректить ни по Accept-Language, ни по остаточной куке.
// hreflang отдаём в metadata, а не Link-заголовком, поэтому alternateLinks: false.
export const routing = defineRouting({
  locales,
  defaultLocale: 'ru',
  localePrefix: 'as-needed',
  localeCookie: false,
  localeDetection: false,
  alternateLinks: false,
});

/**
 * Сужает сегмент `[locale]` до типа Locale. Next типизирует params как string,
 * а невалидные значения до страниц не доходят — их отсекает i18n/request.ts.
 */
export function toLocale(value: string): Locale {
  return hasLocale(routing.locales, value) ? value : routing.defaultLocale;
}
